export default __webpack_public_path__ + "static/media/noun_cart_2035418.83a81f2a.svg";